const locationLink = (latitude: number, longitude: number): string =>
  `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`

export default locationLink
